import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { loadingItem, loadingOfqualItem, loadingAoItem } from "../../redux/actions";
import { Skeleton } from "@material-ui/lab";
import { ItemHeader } from "./ItemHeader";
import { SocScrollableAreaTabs } from "./SocScrollableAreaTabs";
import { useItemState } from "../hooks/useItemState";
import { ItemForm } from "./ItemForm";
import { useAuth } from "@ofqual/portal-core/core/hooks";
import { authSelector } from "../../redux/selectors";
import { UserType } from "../../redux/types";


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
  },
}));

export const Item: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { id } = useParams<{ id: string, year: string }>();

  const year = useLocation().pathname.split('/')[2];
  const { userType } = useAuth(authSelector);

  useEffect(() => {
    dispatch(loadingItem(id, year));
    if (userType === UserType.Ofqual) {
      dispatch(loadingOfqualItem(id, year))
    }
    dispatch(loadingAoItem(id, year));

  }, [dispatch, id, year, userType]);

  const state = useItemState(id, year);

   return (
    <div className={classes.root}>

      { state?.item ? ( <ItemHeader state={state} />) : null }

      <Grid container spacing={3}>
        <Grid item md={8}>
          {state?.item ? (
            <ItemForm state={state} />
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>

        <Grid item md={4} xs={12}>
          <SocScrollableAreaTabs itemState={state} />
        </Grid>
      </Grid>
    </div>
  );
};
